const fastAbortBatch = (batch, aborts) => {
  batch.items.forEach(_ref => {
    let {
      id
    } = _ref;
    return aborts[id]?.();
  });
};
const fastAbortAll = aborts => {
  Object.values(aborts).forEach(fn => fn());
};
export { fastAbortAll, fastAbortBatch };